<template>
  <router-link :to="`/view?s=${song.youtubeId}`" class="song-card">
    <img :src="song.thumbnailUrl" />
    <p class="song-name">{{ song.displayName[$i18n.locale.slice(0, 2)] || song.displayName.ja }}</p>
    <p class="song-description">{{ $t(song.type + 'Song') }} - {{ song.releaseAt || new
      Date(song.publishedAt).toLocaleDateString() }}</p>
  </router-link>
</template>

<script>
export default {
  name: 'VideoCard',
  props: {
    song: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.song-card {
  background-color: var(--color-surface);
  text-decoration: none;
  width: 100%;
  height: 100%;
  color: var(--color-text-primary);
  border-radius: 8px;
  transition: transform 0.1s, box-shadow 0.1s;
  box-shadow: 0 2px 4px var(--color-shadow), inset 0 0 0 0px var(--color-primary);
  display: block;
}

.song-card img {
  width: 100%;
  height: auto;
  aspect-ratio: 16/9;
  object-fit: cover;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.song-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 2px 4px var(--color-shadow), inset 0 0 0 1px var(--color-primary);
}

.song-name {
  font-size: 1.2rem;
  font-weight: 500;
  margin: 0.25rem 0 0 0.5rem;
}

.song-description {
  font-size: 0.8rem;
  margin: 0 0 12px 0.5rem;
  color: var(--color-text-secondary);
}

@media (max-width: 600px) {

  .song-card:hover {
    transform: none;
  }
}
</style>
